import React from "react";
import { Link } from "react-router-dom";

const Services = () => {
  const services = [
    {
      title: "Reportage",
      backgroundImage:
        "url('/img/reportage//3/c4ivtudlog2eh1kq3spu_compression.jpg')",
      description:
        "Nous mettons en lumière vos séminaires et la vie de votre entreprise, en capturant les moments essentiels et les échanges significatifs.",
      link: "/photo/reportage",
    },
    {
      title: "Portrait",
      backgroundImage:
        "url('/img/portfolio/portrait/gjgbpltxrqe5hpedpjlw_compression.jpg')",
      description:
        "Explorez notre collection de portraits capturant des moments uniques et des expressions authentiques.",
      link: "/photo/portrait",
    },
    {
      title: "Evénementiel",
      backgroundImage:
        "url('/img/portfolio/evenementiel/NEW-EVENT/3/bfpt8aw9ra7tlp8de3ve_compression.jpg')",
      description:
        " Explorez notre collection de d'evenementiel capturant des moments uniques et des expressions authentiques.",
      link: "/photo/evenementiel",
    },
    {
      title: "Industriel",
      backgroundImage:
        "url('/img/portfolio/industrielle/img13_compression.jpg')",
      description:
        "Explorez notre collection de Photographie industrielle capturant des moments uniques et des expressions authentiques.",
      link: "/photo/industriel",
    },
    {
      title: "Packshot",
      backgroundImage: "url('/img/portfolio/packshot/img11_compression.jpg')",
      description:
        "Nous réalisons des pack Shots précis et soignés pour mettre en valeur vos produits. Chaque image est conçue pour attirer l’attention de vos clients, en révélant les détails et la qualité qui distinguent vos offres.",
      link: "/photo/packshot",
    },
    {
      title: "Mariage",
      backgroundImage:
        "url('/img/mariage/4/sjuamkh310hunk6vdltq_compression.jpg')",
      description:
        "Explorez notre collection de mariage capturant des moments uniques et des expressions authentiques.",
      link: "/photo/mariage",
    },
  ];

  return (
    <section className="services2 not section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div data-aos="fade-up" className="col-md-12 mb-30 text-center">
            <h2 className="section-title2 background-text">
              <span>Portfolio</span>
            </h2>
            <hr className="border-1" />
            <p className="section-title2">
              Parcourez notre sélection d’albums photos, immortalisant des
              instants inoubliables, des expressions sincères et des moments
              marquants. 
              <br/>
              Qu’il s’agisse d’un reportage, d’un portrait, d’un
              événement ou d’un mariage, chaque photographie dévoile une
              histoire unique. Découvrez nos albums et laissez-vous emporter par
              l’émotion et la beauté de chaque image.
            </p>
          </div>
        </div>
        <div data-aos="fade-up" data-aos-delay="300" className="row">
          {services.map((service, index) => (
            <div className="col-md-4" key={index}>
              <div className="square-flip">
                <div
                  className="square bg-img"
                  style={{ backgroundImage: service.backgroundImage }}
                >
                  <div className="square-container d-flex align-items-end justify-content-end">
                    <div className="box-title">
                      <h4>{service.title}</h4>
                    </div>
                  </div>
                  <div className="flip-overlay"></div>
                </div>
                <div className="square2">
                  <div className="square-container2">
                    <h4>{service.title}</h4>
                    <p>
                      <i>{service.description}</i>
                    </p>
                    <Link to={service.link} className="button-fourth">
                      Voir Plus
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
